// Hybrid: starts with default fallback list, then synced from API
import api from './api';

// Default fallback (used before first API fetch and as offline fallback)
export const DEFAULT_VIDEO_CATEGORIES = [
  { value: 'plc', ar: 'PLC', en: 'PLC', icon: '🔧' },
  { value: 'scada', ar: 'SCADA', en: 'SCADA', icon: '📊' },
  { value: 'hmi', ar: 'HMI', en: 'HMI', icon: '🖥️' },
  { value: 'drives', ar: 'محركات', en: 'Drives', icon: '⚡' },
  { value: 'robotics', ar: 'روبوتات', en: 'Robotics', icon: '🤖' },
  { value: 'networks', ar: 'شبكات صناعية', en: 'Industrial Networks', icon: '🌐' },
  { value: 'sensors', ar: 'حساسات', en: 'Sensors', icon: '🎯' },
  { value: 'general', ar: 'عام', en: 'General', icon: '📚' },
];

// Mutable runtime cache (kept for backwards compatibility with existing imports)
export let VIDEO_CATEGORIES = [...DEFAULT_VIDEO_CATEGORIES];

const fromApi = (c) => ({ value: c.slug, ar: c.nameAr, en: c.nameEn, icon: c.icon || '📚', id: c.id, order: c.order || 0 });

let cache = null;
let inFlight = null;

export const fetchCategories = async () => {
  if (cache) return cache;
  if (inFlight) return inFlight;
  inFlight = (async () => {
    try {
      const { data } = await api.get('/categories');
      const list = (Array.isArray(data) ? data : []).map(fromApi);
      if (list.length > 0) {
        VIDEO_CATEGORIES = list;
        cache = list;
        return list;
      }
    } catch { /* fallback below */ }
    cache = DEFAULT_VIDEO_CATEGORIES;
    return DEFAULT_VIDEO_CATEGORIES;
  })();
  const r = await inFlight;
  inFlight = null;
  return r;
};

// Force refresh after admin mutates categories
export const invalidateCategoriesCache = () => { cache = null; inFlight = null; };

export const getCategoryLabel = (value, lang) => {
  const list = cache || VIDEO_CATEGORIES;
  const c = list.find(x => x.value === value);
  if (!c) return value;
  return lang === 'ar' ? c.ar : c.en;
};
